import "./Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__left">
        <span>© {currentYear} TOPunt Gent</span>

        <span className="footer__divider">•</span>

        <span>POWER Registratie System</span>
      </div>

      <div className="footer__right">
        <span>Developed by Khaled Abumarasa</span>

        <span className="footer__divider">•</span>

        <span>Beveiligd intern platform</span>
      </div>
    </footer>
  );
}
